import React, { useEffect, useRef, useState } from 'react';
import { Typography, Card, LinearProgress } from '@mui/material';
import './ProjectCard.css';

import {
  getEmployeesInProject,
  getProjectById,
} from '../../services/ProjectService';
import { Box } from '@mui/system';
import { RESOURCE_HEADING } from './ProjectConstants';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch } from 'react-redux';
import {
  DATAGRID_FILTER_CONFIG,
  SHOW_NOTIFICATION,
  UserType,
} from '../../constants';

const ProjectCardComponent3 = (props) => {
  const { project } = props;
  const [loading, setLoading] = useState(true);
  const [projectUsers, setProjectUsers] = React.useState([]);
  const [loadTable, setLoadTable] = useState(true);
  const dispatch = useDispatch();
  const [oneProject, setOneProject] = React.useState({});
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  useEffect(() => {
    loadData();
  }, [project]);

  const loadData = async () => {
    const EmployeesInProject = await getEmployeesInProject(project.projectId);
    if (EmployeesInProject.isError === false) {
      setProjectUsers((prevUsers) => [
        ...EmployeesInProject.data.content.sort((a, b) => {
          if (a.status === 'ACTIVE' && b.status !== 'ACTIVE') return -1;
          if (a.status !== 'ACTIVE' && b.status === 'ACTIVE') return 1;
          return 0;
        }),
      ]);
    }
    setLoading(false);
    setLoadTable(false);
    if (EmployeesInProject.status !== 200) {
      dipatchNotification(EmployeesInProject.type, EmployeesInProject.message);
    }
  };

  const columns = [
    {
      field: 'employeeName',
      headerName: 'Name',
      flex: 0.8,
      renderCell: (params) =>
        params.row.status === 'ACTIVE' ? (
          <Typography>{params.row.employeeName}</Typography>
        ) : (
          <Typography sx={{ color: 'gray' }}>
            {params.row.employeeName}
          </Typography>
        ),
    },
    {
      field: 'isManager',
      headerName: 'Role',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <>
          {params.row.status === 'ACTIVE' ? (
            <Typography>
              {params.row.isManager ? 'Manager' : 'Team Member'}
            </Typography>
          ) : (
            <Typography sx={{ color: 'gray' }}>
              {params.row.isManager ? 'Manager' : 'Team Member'}
            </Typography>
          )}
        </>
      ),
    },
  ];

  return (
    <Card variant="outlined" sx={{ mb: 1 }}>
      {loading ? (
        ''
      ) : (
        <Box>
          <Box className="project-container" style={{ overflow: 'auto' }}>
            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box style={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography
                  variant="h6"
                  noWrap
                  sx={{
                    fontFamily: 'sans-serif',
                    fontSize: '1.7rem',
                    textTransform: 'capitalize',
                    color: 'navy',
                    marginBottom: '0.8rem',
                  }}
                >
                  {project.projectName}
                </Typography>
              </Box>
            </Box>
            <Box className="project-card-subhead">
              <strong>{RESOURCE_HEADING}</strong>
              <Box style={{ height: '350px' }}>
                <DataGrid
                  sx={DATAGRID_FILTER_CONFIG}
                  rows={projectUsers}
                  columns={columns}
                  hideFooter
                  components={{
                    LoadingOverlay: LinearProgress,
                  }}
                  loading={loadTable}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default ProjectCardComponent3;
